import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { queryDepartTreeList } from '@/api/api';
export default {
  name: 'JSelectDepartModal',
  props: ['modalWidth', 'multi', 'rootOpened', 'departId'],
  data: function data() {
    return {
      visible: false,
      confirmLoading: false,
      treeData: [],
      autoExpandParent: true,
      expandedKeys: [],
      dataList: [],
      checkedKeys: [],
      checkedRows: [],
      searchValue: ""
    };
  },
  created: function created() {
    this.loadDepart();
  },
  watch: {
    departId: function departId() {
      this.initDepartComponent();
    }
  },
  methods: {
    show: function show() {
      this.visible = true;
      this.checkedRows = [];
      this.checkedKeys = [];
      console.log("this.multi", this.multi);
    },
    loadDepart: function loadDepart() {
      var _this = this;

      queryDepartTreeList().then(function (res) {
        if (res.success) {
          var arr = _toConsumableArray(res.result);

          _this.reWriterWithSlot(arr);

          _this.treeData = arr;

          _this.initDepartComponent();

          if (_this.rootOpened) {
            _this.initExpandedKeys(res.result);
          }
        }
      });
    },
    initDepartComponent: function initDepartComponent() {
      var names = '';

      if (this.departId) {
        var currDepartId = this.departId;

        var _iterator = _createForOfIteratorHelper(this.dataList),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (currDepartId.indexOf(item.key) >= 0) {
              names += "," + item.title;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (names) {
          names = names.substring(1);
        }
      }

      this.$emit("initComp", names);
    },
    reWriterWithSlot: function reWriterWithSlot(arr) {
      var _iterator2 = _createForOfIteratorHelper(arr),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;

          if (item.children && item.children.length > 0) {
            this.reWriterWithSlot(item.children);
            var temp = Object.assign({}, item);
            temp.children = {};
            this.dataList.push(temp);
          } else {
            this.dataList.push(item);
            item.scopedSlots = {
              title: 'title'
            };
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    },
    initExpandedKeys: function initExpandedKeys(arr) {
      if (arr && arr.length > 0) {
        var keys = [];

        var _iterator3 = _createForOfIteratorHelper(arr),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var item = _step3.value;

            if (item.children && item.children.length > 0) {
              keys.push(item.id);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        this.expandedKeys = [].concat(keys);
      } else {
        this.expandedKeys = [];
      }
    },
    onCheck: function onCheck(checkedKeys, info) {
      var _this2 = this;

      if (!this.multi) {
        var arr = checkedKeys.checked.filter(function (item) {
          return _this2.checkedKeys.indexOf(item) < 0;
        });
        this.checkedKeys = _toConsumableArray(arr);
        this.checkedRows = [info.node.dataRef];
      } else {
        this.checkedKeys = checkedKeys.checked;
        this.checkedRows.push(info.node.dataRef);
      } //this.$emit("input",this.checkedKeys.join(","))
      //console.log(this.checkedKeys.join(","))

    },
    onSelect: function onSelect(selectedKeys, info) {
      console.log(selectedKeys);
      var keys = [];
      keys.push(selectedKeys[0]);

      if (!this.checkedKeys || this.checkedKeys.length == 0 || !this.multi) {
        this.checkedKeys = [].concat(keys);
        this.checkedRows = [info.node.dataRef];
      } else {
        var currKey = info.node.dataRef.key;

        if (this.checkedKeys.indexOf(currKey) >= 0) {
          this.checkedKeys = this.checkedKeys.filter(function (item) {
            return item != currKey;
          });
          this.checkedRows = this.checkedRows.filter(function (item) {
            return item.key != currKey;
          });
        } else {
          var _this$checkedKeys;

          this.checkedRows.push(info.node.dataRef);

          (_this$checkedKeys = this.checkedKeys).push.apply(_this$checkedKeys, keys);
        }
      }
    },
    onExpand: function onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    handleSubmit: function handleSubmit() {
      if (!this.checkedKeys || this.checkedKeys.length == 0) {
        this.$emit("ok", '');
      } else {
        this.$emit("ok", this.checkedRows, this.checkedKeys.join(","));
      }

      this.handleClear();
    },
    handleCancel: function handleCancel() {
      this.handleClear();
    },
    handleClear: function handleClear() {
      this.visible = false;
      this.checkedKeys = [];
    },
    getParentKey: function getParentKey(currKey, treeData) {
      var parentKey;

      for (var i = 0; i < treeData.length; i++) {
        var node = treeData[i];

        if (node.children) {
          if (node.children.some(function (item) {
            return item.key === currKey;
          })) {
            parentKey = node.key;
          } else if (this.getParentKey(currKey, node.children)) {
            parentKey = this.getParentKey(currKey, node.children);
          }
        }
      }

      return parentKey;
    },
    onSearch: function onSearch(value) {
      var _this3 = this;

      var expandedKeys = this.dataList.map(function (item) {
        if (item.title.indexOf(value) > -1) {
          return _this3.getParentKey(item.key, _this3.treeData);
        }

        return null;
      }).filter(function (item, i, self) {
        return item && self.indexOf(item) === i;
      });
      Object.assign(this, {
        expandedKeys: expandedKeys,
        searchValue: value,
        autoExpandParent: true
      });
    }
  }
};